import MailSpamProtectionController from "./Controller/MailSpamProtectionController";
import InfiniteScrollController from "./Controller/InfiniteScrollController";
import GalleryController from "./Controller/GalleryController";

MailSpamProtectionController.mount();
InfiniteScrollController.mount();
GalleryController.mount();
